import { of as observableOf } from "rxjs";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { User } from "../../user/user.model";
import { mainMenu, settingsLabel, userDropdown } from "./navigation.const";
import { role } from "../../user/role.const";
import { MenuItem } from "primeng/api";

export interface RoleMenuItem extends MenuItem {
  items?: RoleMenuItem[];
  roles: string | string[];
  module?: string;
  classList?: string;
  callback?: string;
}

@Injectable()
export class NavigationService {
  public userDropdownOptionsDefinition: RoleMenuItem[] = userDropdown;

  public menuDefinition: RoleMenuItem[] = mainMenu;

  private navigationItems: Observable<RoleMenuItem[]> = observableOf(
    this.menuDefinition,
  );
  private userDropdownItems: Observable<RoleMenuItem[]> = observableOf(
    this.userDropdownOptionsDefinition,
  );

  constructor() {}

  public getItems(): Observable<RoleMenuItem[]> {
    return this.navigationItems;
  }

  public getUserDropdownOptions(): Observable<RoleMenuItem[]> {
    return this.userDropdownItems;
  }

  public setVisibleIfRole(user: User, item: RoleMenuItem): boolean {
    let visibility = false;

    if (0 < item.roles.length) {
      for (const roleName of item.roles) {
        if (user.getRoles().includes(roleName)) {
          visibility = true;
        }
      }

      return visibility;
    }
  }

  public getItemWithClassesUpdatedByUserRole(
    user: User,
    item: RoleMenuItem,
  ): RoleMenuItem {
    if (item && item.label === settingsLabel) {
      if (!user.hasRole(role.superAdmin)) {
        item.classList = "d-none d-lg-inline-block";
      }
    }

    return item;
  }
}
